import React, { useEffect, useState } from "react";

const slugify = (text) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^\w]+/g, "-");

function TableOfContents({ content }) {
  const [headings, setHeadings] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [pageUrl, setPageUrl] = useState("");

  useEffect(() => {
    setPageUrl(window.location.href); // current page URL
  }, []);

  useEffect(() => {
    if (!content) return;
    const headingRegex = /^#{1,6}\s+(.*)/gm;
    const found = [];
    let match;
    let currentTop = null;
    while ((match = headingRegex.exec(content)) !== null) {
      const raw = match[0];
      const level = raw.split(" ")[0].length;
      if (level <= 1) continue; // skip main title
      const text = match[1].trim();
      const id = slugify(text);
      if (level === 2) {
        currentTop = { id, text, level, children: [] };
        found.push(currentTop);
      } else if (currentTop) {
        currentTop.children.push({ id, text, level });
      }
    }
    setHeadings(found);
  }, [content]);

  useEffect(() => {
    if (headings.length === 0) return;

    const all = [];
    headings.forEach((h) => {
      all.push({ id: h.id });
      h.children.forEach((c) => all.push({ id: c.id }));
    });

    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100; // offset for navbar
      let current = all[0]?.id;
      for (const h of all) {
        const el = document.getElementById(h.id);
        if (el && el.offsetTop <= scrollPosition) {
          current = h.id;
        } else {
          break;
        }
      }
      setActiveId(current);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [headings]);

  const isGroupActive = (h) => {
    if (activeId === h.id) return true;
    return h.children.some((c) => c.id === activeId);
  };

  if (headings.length === 0) return null;

  return (
    <aside className="hidden lg:block w-64 text-left">
      <div className="sticky top-20">
        <p className="text-xl mb-5"><i class='bx bx-spreadsheet bx-fw' ></i> Table of Contents</p>
        <ul className="text-md space-y-3">
          {headings.map((h) => (
            <li key={h.id}>
              <a
                href={`#${h.id}`}
                className={`text-slate-500 hover:text-yellow-400 ${
                  activeId === h.id ? "text-yellow-400" : ""
                }`}
              >
                {h.text}
              </a>
              {isGroupActive(h) && h.children.length > 0 && (
                <ul className="mt-3 space-y-3">
                  {h.children.map((child) => (
                    <li
                      key={child.id}
                      style={{ marginLeft: `${(child.level - 3) * 16}px` }}
                      className={`pl-2 border-l-2 ${
                        activeId === child.id
                          ? "border-yellow-400"
                          : "border-slate-500 hover:border-yellow-400"
                      }`}
                    >
                      <a
                        href={`#${child.id}`}
                        className={`text-slate-500 hover:text-yellow-400 ${
                          activeId === child.id ? "text-yellow-400" : ""
                        }`}
                      >
                        {child.text}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>

        {/* Share Buttons 
        <div className="mt-8">
          <p className="text-lg mb-3">Share</p>
          <div className="flex flex-wrap gap-3 text-2xl">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                pageUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 rounded hover:text-blue-700"
            >
             <i class='bx bxl-facebook-circle' ></i>
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                pageUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-sky-600"
            >
            <i class='bx bxl-twitter'></i>
            </a>
            <a
              href={`https://www.reddit.com/submit?url=${encodeURIComponent(
                pageUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-orange-600"
            >
              <i class='bx bxl-reddit' ></i>
            </a>
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                pageUrl
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-blue-800"
            >
             <i class='bx bxl-linkedin' ></i>
            </a>
          </div>
        </div> */}
      </div>
    </aside>
  );
}

export default TableOfContents;
